import { PATCH } from "../APiHelper/API";

export const updateSelections = (
  data,
  onSuccess,
  onError
) => {
  PATCH(`/api/v1/squads/selections`, data, onSuccess, onError);
};
